export default __webpack_public_path__ + "static/wallpaper-3-mb-1487f28a44b7799398b379403102dcd1.png";